import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageThree/sectionTwo/pagar.png";
import img2 from "../../../assets/img/landingPageThree/sectionTwo/bonus.png";
import img3 from "../../../assets/img/landingPageThree/sectionTwo/saude.png";
import img4 from "../../../assets/img/landingPageThree/sectionTwo/treinamento.png";
import img5 from "../../../assets/img/landingPageThree/sectionTwo/uniforme.png";
import img6 from "../../../assets/img/landingPageThree/sectionTwo/desconto.png";
import img7 from "../../../assets/img/landingPageThree/sectionTwo/dente.png";
import img8 from "../../../assets/img/landingPageThree/sectionTwo/pagar.png";
import arrow from "../../../../assets/img/components/buttonBlue.webp"

const SERVICES = [
  { key: "lp3_service1", img: img1 },
  { key: "lp3_service2", img: img2 },
  { key: "lp3_service3", img: img3 },
  { key: "lp3_service4", img: img4 },
  { key: "lp3_service5", img: img5 },
  { key: "lp3_service6", img: img6 },
  { key: "lp3_service7", img: img7 },
  { key: "lp3_service8", img: img8 },
];

function SectionTwo() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const breakpoints = {
    1300: {
      slidesPerView: 4,
    },
    1000: {
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
    },
    600: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="services" className={`sectionTwo ${isVisible ? "visible" : ""}`}>
        <img className={`arrow1 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <img className={`arrow2 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <div className="sectionTwoTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_services_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp3_services_subtitle")}
          </p>
        </div>
        <Swiper
          slidesPerView={4}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {SERVICES.map((service) => (
            <SwiperSlide key={service.key}>
              <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                <img src={service.img} alt="" />
                <p>{t(service.key)}</p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionTwo;
